/**
 *   dialog option
 */

export const payerInfoOptionDialog = {
	menuBtn: false,
	labelWidth: 180,
	labelPosition: 'left',
	column: [
		{
			label: '付款人姓名',
			prop: 'payer',
			span: 24,
			rules: [
				{
					required: true,
					message: '请输入付款人姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '付款人账号',
			prop: 'payAccount',
			placeholder: '请输入付款人账号(按实际情况填写，如：微信钱包，支付宝钱包)',
			span: 24,
			rules: [
				{
					required: true,
					message: '请输入付款人账号(按实际情况填写，如：微信钱包，支付宝钱包)',
					trigger: 'blur',
				},
			],
		},
		{
			label: '代付款原因',
			prop: 'payFor',
			placeholder: '请输入代付款原因(建议填写：购买保险)',
			span: 24,
			rules: [
				{
					required: true,
					message: '请输入代付款原因(建议填写：购买保险)',
					trigger: 'blur',
				},
			],
		},
		{
			label: '付款人与投保企业关系',
			prop: 'payerWithEnterprise',
			placeholder: '请输入付款人与投保企业关系(例如：负责人)',
			span: 24,
			rules: [
				{
					required: true,
					message: '请输入付款人与投保企业关系(例如：负责人)',
					trigger: 'blur',
				},
			],
		},
		{
			label: '示例',
			prop: 'example',
			type: 'upload',
			value: 'images/my_pay_example.jpg',
			listType: 'picture-img',
			display: true,
			propsHttp: {
				res: 'data',
			},
			disabled: true,
		},
	],
}

export const ChannelChangeOptionDialog = {
	card: true,
	border: true,
	stripe: true,
	menu: false,
	header: false,
	align: 'center',
	column: [
		{
			label: '渠道名称',
			prop: 'name',
		},
		{
			label: '所属分公司',
			prop: '$parentId',
		},
		{
			label: '手机号',
			prop: 'contactPersonMobile',
			width: 150,
		},
		{
			label: '状态',
			prop: '$status',
		},
		{
			label: '备注',
			prop: 'remark',
		},
	],
}
